import { useMemo } from "react";
import { useParams } from "react-router-dom";

export const useSharedProjectParams = () => {
  const { company, project, projectHash, versionKey } = useParams();
  
  const sanitizedCompany = useMemo(() => (
    company
      ? encodeURIComponent(company).replace(/(%[0-9A-Fa-f]{2})*/g, "")
      : company
  ), [ company ]);
  
  const sanitizedProject = useMemo(() => (
    project
      ? encodeURIComponent(project).replace(/(%[0-9A-Fa-f]{2})*/g, "")
      : project
  ), [ project ]);

  const sanitizedProjectHash = useMemo(() => (
    projectHash
      ? encodeURIComponent(projectHash).replace(/(%[0-9A-Fa-f]{2})*/g, "")
      : projectHash
  ), [ projectHash ]);

  const sanitizedVersionKey = useMemo(() => (
    versionKey
      ? encodeURIComponent(versionKey).replace(/(%[0-9A-Fa-f]{2})*/g, "")
      : versionKey
  ), [ versionKey ]);
  
  const shareKey = useMemo(() => (
    sanitizedCompany && sanitizedProject
      ? `${sanitizedCompany}/${sanitizedProject}/${sanitizedProjectHash}`
      : sanitizedProjectHash
  ), [ sanitizedCompany, sanitizedProject, sanitizedProjectHash ]);
  
  return {
    company: sanitizedCompany,
    project: sanitizedProject,
    projectHash: sanitizedProjectHash,
    versionKey: sanitizedVersionKey,
    shareKey
  };
};
